import * as React from 'react'

import debounce from 'lodash/debounce'

import { useCallback } from 'modules/core/hooks/useCallback'
import { useEffect } from 'modules/core/hooks/useEffect'
import { BusinessError } from 'modules/core/lib/errors'
import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'

export type UserData = {
  email: string
}

type FetchedUserData = {
  email: string
}

export const useDebouncedFetchUser = (email: string) => {
  const [user, setUser] = React.useState<UserData>()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedFetchUser = useCallback(
    debounce(async (email: string) => {
      const data = await fetchUserDataByEmail(email)
      if (data) {
        const fetchedUser = {
          email: data.email,
        }
        setUser(fetchedUser)
      } else {
        setUser(undefined)
      }
    }, 500),
    []
  )

  useEffect(() => {
    if (email) {
      debouncedFetchUser(email)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email])

  return {
    user,
  }
}

const fetchUserDataByEmail = async (email: string): Promise<FetchedUserData | undefined> => {
  try {
    // This endpoint is expected to throw a resource not found error
    // if the email address does not exist.
    const api = ApiClient()
    return await api.post('/emails/validate', {
      email,
    })
  } catch (error) {
    if (!(error instanceof BusinessError)) {
      throw error
    }
    //resource not found return undefined
  }
}
